export default "__VITE_ASSET__C9mo6vLG__"